import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions/chat';
import ChatSchedule from 'components/chat/Schedule';


export default connect(
  state => ({
    schedule: state.chat.main.schedule,
    outOfScheduleMessage: state.chat.main.queueProperties.outOfScheduleMessage
  }),
  dispatch => ({ })
)(ChatSchedule);



// WEBPACK FOOTER //
// ./containers/chat/Schedule.js